window.MC_CERTS = {
  "certs": [
    {
      "id": "certipur-us",
      "name": "CertiPUR-US",
      "verified": true,
      "badge": "https://mattresscrafters.com.au/cdn/shop/files/certipur_us.jpg",
      "applies_to": [
        "boutique-mattress-memory-foam",
        "boutique-deluxe-mattress",
        "luxury-mattress-australia-boutique",
        "boutique-extra-firm-mattress",
        "boutique-craft-cell-mattress",
        "hybrid-mattress-australia"
      ],
      "description": "Foams tested by an independent lab for content, emissions and durability. The certificate means the foam is made without ozone depleters, certain flame retardants, heavy metals and formaldehyde, and that it holds its performance under a standard durability test."
    },
    {
      "id": "oeko-tex-standard-100",
      "name": "OEKO-TEX Standard 100",
      "verified": true,
      "badge": null,
      "applies_to": [
        "ardor-low-profile-memory-foam",
        "ardor-balance-medium-2-0-memory-foam-pillow",
        "ardor-balance-high-3-0-memory-foam-pillow"
      ],
      "description": "Every part of a textile product tested for harmful substances against a list that is stricter than most national laws. A pillow carrying it has been tested down to the thread."
    },
    {
      "id": "australian-made-therapedic",
      "name": "Australian Made (Therapedic range)",
      "verified": false,
      "badge": null,
      "applies_to": [
        "chiro-luxe",
        "exquisite-signature-mattress",
        "exquisite-premier-mattress",
        "elevate-essential-mattress"
      ],
      "description": "Every Therapedic mattress in this range is assembled in Australia under Therapedic Worldwide licensed technology. This is a placeholder entry pending a formal Australian Made certification mark, it is not yet a registered certification."
    }
  ],
  "byHandle": {
    "boutique-mattress-memory-foam": [
      "certipur-us"
    ],
    "boutique-deluxe-mattress": [
      "certipur-us"
    ],
    "luxury-mattress-australia-boutique": [
      "certipur-us"
    ],
    "boutique-extra-firm-mattress": [
      "certipur-us"
    ],
    "boutique-craft-cell-mattress": [
      "certipur-us"
    ],
    "hybrid-mattress-australia": [
      "certipur-us"
    ],
    "ardor-low-profile-memory-foam": [
      "oeko-tex-standard-100"
    ],
    "ardor-balance-medium-2-0-memory-foam-pillow": [
      "oeko-tex-standard-100"
    ],
    "ardor-balance-high-3-0-memory-foam-pillow": [
      "oeko-tex-standard-100"
    ],
    "chiro-luxe": [
      "australian-made-therapedic"
    ],
    "exquisite-signature-mattress": [
      "australian-made-therapedic"
    ],
    "exquisite-premier-mattress": [
      "australian-made-therapedic"
    ],
    "elevate-essential-mattress": [
      "australian-made-therapedic"
    ]
  }
};
